/**
* Created by vouill on 2019-02-05.
*/

<template>
  <div class="c-container">
    <SideMenu :authors="vuexApiData.items"/>
    <Content
      :authors="vuexApiData.items"
      :includes="vuexApiData.includes"/>
  </div>
</template>
<style scoped>
.c-container {
  display: flex;
  margin: auto;
  max-width: 1200px;
  margin-top: 1em;
}

@media screen and (max-width: 800px) {
  .c-container {
    flex-direction: column;
  }
}
</style>

<script>
import SideMenu from "./side-menu";
import Content from "./Content";
export default {
  name: "AuthorContainer",
  props: { vuexApiData: Object },
  components: { Content, SideMenu },
  data() {
    return {};
  }
};
</script>
